import { LitElement, html } from 'lit';
import { property } from 'lit/decorators.js';
import { classMap } from 'lit/directives/class-map.js';
import { styles } from './sds-heading.styles';
import { SDS_SIZES } from '../types';

type Level = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
type DisplaySize = 'l' | 'm' | 's' | SDS_SIZES;

export interface SDSHeadingProps {
	level?: Level;
	size?: DisplaySize;
}

export class SDSHeadingComponent extends LitElement {
	static override styles = [styles];

	@property({ type: String, reflect: true }) level: SDSHeadingProps['level'] = 'h1';
	@property({ type: String, reflect: true }) size?: SDSHeadingProps['size'];

	override render() {
		const headingClasses = {
			'sds-heading': true,
			'sds-heading--xl': this.size === 'xl',
			'sds-heading--lg': this.size === 'l' || this.size === 'lg',
			'sds-heading--md': this.size === 'm' || this.size === 'md',
			'sds-heading--sm': this.size === 's' || this.size === 'sm',
			'sds-heading--xs': this.size === 'xs',
		};

		switch (this.level?.toLowerCase()) {
			case 'h1':
				return html`<h1 class=${classMap(headingClasses)}><slot></slot></h1>`;
			case 'h2':
				return html`<h2 class=${classMap(headingClasses)}><slot></slot></h2>`;
			case 'h3':
				return html`<h3 class=${classMap(headingClasses)}><slot></slot></h3>`;
			case 'h4':
				return html`<h4 class=${classMap(headingClasses)}><slot></slot></h4>`;
			case 'h5':
				return html`<h5 class=${classMap(headingClasses)}><slot></slot></h5>`;
			case 'h6':
				return html`<h6 class=${classMap(headingClasses)}><slot></slot></h6>`;
			default:
				return html`<h1 class=${classMap(headingClasses)}><slot></slot></h1>`;
		}
	}
}
